export default __webpack_public_path__ + "static/media/IGEO_BIM_2.a89f5f36.jpg";